<template>
  <div>

    <!-- v-ripple -->
    <div class="holder">
      <button
        v-if="count"
        type="button"
        class="btn"
        @click="showModal">
        <div
        id="ranger-activator"
        class="rg-btn rg-toolbar-side-icon">
          <i aria-hidden="true" class="rg-icon material-icons">radar</i>
          <!-- <div class="rg-badge">{{ count }}</div> -->
        </div>
        <div class="rg-badge distance">{{ closestInRange }}km</div>
      </button>
    </div>
    <modal
      v-bind:modal-visible="rangerState"
      modal-type="bottom-sheet"
      modal-Id="ranger">
      <div slot="toolbar-title">
        Fires in {{range}}km Range of {{ displayCoordinates }}
      </div>
      <template slot="body">
        <h1>Warning:</h1>
        <p>
          <b>Range estimates are only APPROXIMATE and may have a variance of up to 0.5km.  Follow evacuation
          orders and instructions from local authorities.
          </b>
        </p>
        <!-- <p>Fire Points Locations and Fire Perimeters are provided from Government Open Data,
          this means they are subject to delays in updating and are not real time. Points do
          not represent the area of a fire, so depending on its size the fire may be considerably
          closer than indicated.  Perimeters are often only sporadically updated, and may not
          represent the current extent of a fire.
        </p> -->
        <!-- <p>This warning is the simply the result of a limitation of the available data.</p> -->
        <div v-if="inRangeFeatures && inRangeFeatures.length">
          <div v-for="(layer) in orderedInRangeFeatures" :key="layer.id">
            <div><h3>{{ layer.title }}</h3></div>
            <div v-if="layer.features.length">
              <div class="rg-list">
                <div v-for="(feature, index) in layer.features"
                :key="index"
                class="rg-list-tile three-line">
                <div class="rg-tile-avatar">
                  <img
                    :src="fireStatusIcon(feature.properties.FIRE_STATUS || 'nrt')"
                    width="42" height="42"/>
                </div>
                  <div class="rg-tile-content">
                    <div class="rg-tile-title">
                      <h3>{{ feature.properties.range }}km
                        <span v-if="feature.properties.satellite">
                        - {{ feature.properties.satellite.toUpperCase() }} </span>
                        - {{ feature.properties.FIRE_NUMBER }}
                        - {{ feature.properties.FIRE_STATUS }}
                      </h3>
                    </div>
                    <div class="rg-tile-sub-title">
                      <div v-if="feature.geometry.type === 'Point'">Location:
                        {{ feature.geometry.coordinates[0].toFixed(4) }},
                        {{ feature.geometry.coordinates[1].toFixed(4) }}
                      </div>
                      <div
                        v-if="feature.properties.FIRE_SIZE_HECTARES || feature.properties.CURRENT_SIZE">
                        Area:
                          {{ feature.properties.FIRE_SIZE_HECTARES || feature.properties.CURRENT_SIZE }} ha
                      </div>
                      <div v-if="feature.properties.timestamp">
                        Processed: {{ localDataTime(feature.properties.timestamp) }}
                      </div>
                      <!-- <div v-if="feature.properties.acq_datetime">
                        Satillite Aquisition Time: {{ utcToLocalTime(feature.properties.acq_datetime) }}
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr class="rg-divider" />
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>

import { mapState, mapActions, mapGetters } from 'vuex';
import {
  point,
  explode,
  distance,
  nearestPoint,
} from '@turf/turf';

import {
  cloneDeep,
} from 'lodash';

import modal from './modal.vue';

export default {
  name: 'RangerView',

  components: {
    modal,
  },

  data() {
    return {
      rangerState: false,
    };
  },


  created() {
    this.$bus.$on('modal-close-event', this.closeView);
  },

  beforeDestroy() {
    this.$bus.$off('modal-close-event');
  },

  computed: {
    ...mapState(['inRangePoints', 'inRangeFeatures', 'coordinates', 'range']),
    ...mapGetters(['getCoordinates']),

    count() {
      let c = 0;
      this.inRangeFeatures.forEach((layer) => {
        console.log(layer.id, layer.features, layer.features.length);
        c += layer.features.length;
      });
      console.log('count :: c', c);
      return c;
    },

    displayCoordinates() {
      const c = this.getCoordinates;
      if (!c) return null;
      return `${c.geometry.coordinates[0].toFixed(4)}, ${c.geometry.coordinates[1].toFixed(4)}`;
    },

    orderedInRangeFeatures() { // make work for points and polys
      let ordered = cloneDeep(this.inRangeFeatures);
      let closest = 50000;
      ordered.forEach((layer) => {
        layer.features.forEach((feature) => {
          const { type } = feature.geometry;
          if (type === 'Polygon' || type === 'MultiPolygon') {
            const nP = this.nearestPolyPoint(feature);
            // eslint-disable-next-line no-param-reassign
            feature.properties.point = nP.geometry.coordinates;
            // eslint-disable-next-line no-param-reassign
            feature.properties.range = this.distanceToPoly(nP);
          }
          if (type === 'Point') {
            // eslint-disable-next-line no-param-reassign
            feature.properties.range = this.distanceToPoint(
              feature.geometry.coordinates[0],
              feature.geometry.coordinates[1],
            );
          }
        });
        console.log('layer', layer.features);
        layer.features.sort((a, b) => a.properties.range - b.properties.range);
        // eslint-disable-next-line no-param-reassign
        layer.features = layer.features.slice(0, 5);
        if (layer.features[0].properties.range < closest) {
          closest = layer.features[0].properties.range;
        }
      });
      // // eslint-disable-next-line vue/no-side-effects-in-computed-properties, vue/no-side-effects-in-computed-properties
      // console.log('orderedInRangeFeatures :: ordered', ordered, this.closestPoint);
      // ordered = sortedUniqBy(ordered, 'feature.properties.FIRE_NUMBER');
      return ordered;
    },

    closestInRange() {
      console.log('orderedInRangeFeatures :: closestInRange', this.orderedInRangeFeatures);
      const ranges = [];
      this.orderedInRangeFeatures.forEach(fC => ranges.push(fC.features[0].properties.range));
      const closest = Math.min(...ranges);
      return closest || 0;
    },
  },

  methods: {
    ...mapActions([
      'setInRangeFeatures',
    ]),

    showModal() {
      this.rangerState = true;
    },

    localDataTime(dT) {
      const d = new Date(dT);
      return d.toLocaleTimeString();
    },

    // utcToLocalTime(dt) {
    //   const d = new Date(`${dt} UTC`);
    //   return `${d.toLocaleDateString()} ${d.toLocaleTimeString()}`;
    //   // return dt;
    // },

    confidence(c) {
      const conf = {
        l: 'Low',
        n: 'Nominal',
        h: 'High',
      };
      return conf[c];
    },

    closeView() {
      this.rangerState = false;
      this.setInRangeFeatures([]);
    },

    distanceToPoint(lon, lat) {
      const c = this.getCoordinates;
      if (!c) return null;
      const pt = point([lon, lat]);
      const d = distance(pt, c, { units: 'kilometers' });
      return d.toFixed(1);
    },

    nearestPolyPoint(poly) {
      const c = this.getCoordinates;
      if (!c) return null;
      const exPlode = explode(poly);
      const nearestPt = nearestPoint(c, exPlode);
      return nearestPt;
    },

    distanceToPoly(nearestPt) {
      const c = this.getCoordinates;
      if (!c) return null;
      const d = distance(nearestPt, c, { units: 'kilometers' });
      return d.toFixed(1);
    },

    fireStatusIcon(status) {
      const fireStatus = status.toLowerCase().replaceAll(' ', '-');
      return `static/points/fire-${fireStatus}-point.svg`;
    },
  },
};

</script>
<style lang="less" scoped>
.rg-tile-sub-title {
  margin: 0 16px;
}
</style>
<style lang="less">
@import "../assets/less/variables.less";

.modal-body {
  padding-bottom: 100px;
}

@media (max-width: @xs) {
  .ranger-container {
    flex: 1 1 calc(100% - 44px);
  }

  .modal {
    .rg-toolbar-title,
    .rg-toolbar-title {
      display: none;
    }
  }
}

.rg-list-tile.two-line {
    display: flex;
}
.rg-tile-content {
    flex: 1;
}

.holder {
  display: flex;
  flex: 1;
  position: relative;
  width: 70px;
}
.rg-badge {
  flex: 1;
  border: 1px solid #fff;
  background: #007bff;
  color: #fff;
  border-radius: 4px;
  font-size: 11px;
  font-weight: bold;
  margin-top: 16px;
  margin-left: -2px;
  padding: 1px 4px;

  &.distance {
    position: absolute;
    background: #ff0000;
    top: -16px;
    left: 32px;// margin-left: -2px;
    text-transform: lowercase;
  }
}


.ranger-container {
  flex: 1 1 auto;
  display: flex;
  background: #fff;
  padding: 0;
  border-radius: 5px;
  height: 46px;
}

.ranger-icon {
  flex: 0 0 46px;
  color: @rg-background-color !important;
}

.ranger-input {
  height: 46px;
  background: #fff;
  color: @rg-background-color;
  font-size: 18px;
  flex: 1 1 100%;
  &:focus {
    outline: none;
  }
}

.modal-body {
  height: 100%;
  overflow: hidden;
}

.ranger-results.rg-list {
  height: 100%;
  overflow-y: auto;
  padding-bottom: 64px;
}

@keyframes spin-animation {
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.spin:before {
  display: block;
  transform-origin: center center;
  -webkit-backface-visibility: hidden;
  animation: spin-animation 2s linear infinite;
}

.rotate {
  transform-origin: center center;
  -webkit-backface-visibility: hidden;
  animation: spin-animation 2s linear infinite;
}
</style>
